import { render, staticRenderFns } from "./PlpExternalRegister.vue?vue&type=template&id=a6bf94d8"
import script from "./PlpExternalRegister.vue?vue&type=script&lang=js"
export * from "./PlpExternalRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports